import CardId from './CardId';

export default CardId;
